import React from 'react';

import ShowLessonsModel from './WShowLessonsModel.jsx';

import './LearningPath.css';

const LearningPath = ({ courseConfig }) => {
  return (
    <div className="learning-path">
      <ShowLessonsModel
        courseConfig={courseConfig}
      />
    </div>
  );
};

export default LearningPath;